import { Account, Element, ElementStatus, ElementType, Permission, Product, TeamMember } from '@/models'
import {
  APP_CCP,
  CV_VALUE_COUNTRY_AR,
  CV_VALUE_COUNTRY_BR,
  CV_VALUE_COUNTRY_CL,
  CV_VALUE_COUNTRY_CO,
  CV_VALUE_COUNTRY_DO,
  CV_VALUE_COUNTRY_EC,
  CV_VALUE_COUNTRY_ES,
  CV_VALUE_COUNTRY_MX,
  CV_VALUE_COUNTRY_PE,
  CV_VALUE_COUNTRY_PR,
  DEFAULT_ASSET_TENANT,
  ELEMENT_STATUS_FILE_FORMAT_INDESIGN,
  ELEMENT_STATUS_FILE_FORMAT_WORD
} from '@/utils/constants'
import _ from 'lodash'
import moment from 'moment'

export class Utils {
  public static isProduct(o: Product | Element) {
    return o.type.startsWith('typr')
  }

  public static isElement(o: Product | Element) {
    return !o.type.startsWith('typr')
  }

  public static delay(fn: any, ms: number) {
    let timer: ReturnType<typeof setTimeout>
    return (...args: any) => {
      clearTimeout(timer)
      timer = setTimeout(fn.bind(this, ...args), ms || 0)
    }
  }

  public static getServiceIcon() {
    return 'mdi-account-supervisor'
    // if (['maquetacion-papel'].includes(service.code)) {
    //   icon = 'mdi-camera'
    // } else if (['iconografia'].includes(service.code)) {
    //   icon = 'mdi-tag-faces'
    // } else if (['encargo-produccion-audiovisual', 'proveedores-audiovisuales', 'tratamiento-audiovisual'].includes(service.code)) {
    //   icon = 'mdi-video-image'
    // } else if (['edicion'].includes(service.code)) {
    //   icon = 'mdi-pencil'
    // } else if (['traduccion'].includes(service.code)) {
    //   icon = 'mdi-translate'
    // } else if (['produccion-digital'].includes(service.code)) {
    //   icon = 'mdi-cod-outline'
    // } else if (['soporte-avanzado-produccion'].includes(service.code)) {
    //   icon = 'mdi-face-agent'
    // }
    // return icon
  }

  public static getCountryIcon(country: string) {
    switch (country) {
      case CV_VALUE_COUNTRY_ES:
        return 'fi-es'
      case CV_VALUE_COUNTRY_BR:
        return 'fi-br'
      case CV_VALUE_COUNTRY_CL:
        return 'fi-cl'
      case CV_VALUE_COUNTRY_MX:
        return 'fi-mx'
      case CV_VALUE_COUNTRY_PE:
        return 'fi-pe'
      case CV_VALUE_COUNTRY_DO:
        return 'fi-do'
      case CV_VALUE_COUNTRY_PR:
        return 'fi-pr'
      case CV_VALUE_COUNTRY_CO:
        return 'fi-co'
      case CV_VALUE_COUNTRY_EC:
        return 'fi-ec'
      case CV_VALUE_COUNTRY_AR:
        return 'fi-ar'
      default:
        return 'fi-es'
    }
  }

  public static findElementTypeName(codeId: string, elementTypes: ElementType[]) {
    const elementType = elementTypes.filter((item: ElementType) => item.codeId === codeId)
    if (elementType.length > 0) {
      return elementType[0].name
    } else {
      return codeId
    }
  }

  public static findElementType(codeId: string, elementTypes: ElementType[]) {
    const elementType = elementTypes.filter((item: ElementType) => item.codeId === codeId)
    if (elementType.length > 0) {
      return elementType[0]
    } else {
      return null
    }
  }

  public static compareJSON(obj1: any, obj2: any): any {
    const ret: any = {}
    for (const i in obj2) {
      if (typeof obj1[i] === 'object' && typeof obj2[i] === 'object') {
        if (JSON.stringify(obj1[i]) !== JSON.stringify(obj2[i])) {
          ret[i] = obj2[i]
        }
      } else {
        if (!Object.prototype.hasOwnProperty.call(obj1, i) || obj2[i] !== obj1[i]) {
          ret[i] = obj2[i]
        }
      }
    }
    return ret
  }

  public static getTenantFromProduct(product: Product): string {
    if (!product) {
      return DEFAULT_ASSET_TENANT
    }

    const tenant = product.country?.split('-')
    if (!tenant || tenant.length < 2) {
      return DEFAULT_ASSET_TENANT
    }

    return tenant[1]
  }

  public static clearFilesFromElement(files: ElementStatus[]) {
    if (!files) {
      return null
    }

    let filesReturn: ElementStatus[] = []
    const groupedByFileFormat = _.groupBy(files, 'fileFormat')
    if (groupedByFileFormat[ELEMENT_STATUS_FILE_FORMAT_INDESIGN] && groupedByFileFormat[ELEMENT_STATUS_FILE_FORMAT_INDESIGN].length > 0) {
      filesReturn = groupedByFileFormat[ELEMENT_STATUS_FILE_FORMAT_INDESIGN]
    } else if (groupedByFileFormat[ELEMENT_STATUS_FILE_FORMAT_WORD] && groupedByFileFormat[ELEMENT_STATUS_FILE_FORMAT_WORD].length > 0) {
      filesReturn = groupedByFileFormat[ELEMENT_STATUS_FILE_FORMAT_WORD]
    }

    // Clear country
    const regexContryWithCodsap = /^[a-zA-Z]{2}\d{6}.*$/
    for (let i = 0; i < filesReturn.length; i++) {
      const file = filesReturn[i]
      if (regexContryWithCodsap.test(file.fileName)) {
        file.fileName = file.fileName.slice(2)
      }
    }

    const groupedByFileName = _.groupBy(filesReturn, 'fileName')
    const filesClearDuplicate: ElementStatus[] = []
    for (const key in groupedByFileName) {
      const groupFiles = groupedByFileName[key]
      if (groupFiles.length === 1) {
        filesClearDuplicate.push(groupFiles[0])
      }
      if (groupFiles.length > 1) {
        const orderByPhase = _.orderBy(groupFiles, ['elementStatusType.phase.orderPhase'])
        filesClearDuplicate.push(orderByPhase[orderByPhase.length - 1])
      }
    }
    filesReturn = filesClearDuplicate

    return filesReturn
  }

  public static exportFile(fileData: string, fileName: string, fileType: string) {
    const base64String = fileData
    const binaryString = atob(base64String)
    const len = binaryString.length
    const bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i)
    }

    const a = document.createElement('a')
    const file = new Blob([bytes.buffer], { type: fileType })
    a.href = URL.createObjectURL(file)
    a.download = fileName
    a.click()
  }

  public static downloadCsv(data: any, fileName: string) {
    const blob = new Blob([data], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
  }

  public static getYearsForCampaign(startYear: number) {
    const stop = (new Date()).getFullYear() + 1
    const step = 1
    return Array.from({ length: (stop - startYear) / step + 1 }, (_, i) => startYear + (i * step))
  }

  public static normalizeText(text: string): string {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
  }

  public static truncateText(text: string, maxCharacters: number) {
    if (text.length <= maxCharacters) return text

    return text.substring(0, maxCharacters) + '...'
  }

  public static flattenTreeNodes(tree: any, property: string) {
    const flatList: any[] = []

    function traverse(node: any) {
      flatList.push(node)
      if (node[property] && Array.isArray(node[property])) {
        node[property].forEach(traverse)
      }
    }

    if (Array.isArray(tree)) {
      tree.forEach(traverse)
    } else {
      traverse(tree)
    }

    return flatList
  }

  public static customFilterSelect(options: any, search: string) {
    return options.filter((option: any) => {
      // @ts-ignore
      const label = this.getOptionLabel(option)
      return Utils.normalizeText(label).includes(Utils.normalizeText(search))
    })
  }

  public static customFilterSelectTeamMember(options: any, search: string) {
    return options.filter((option: TeamMember) => {
      const label = option.firstName + ' ' + option.lastName
      return Utils.normalizeText(label).includes(Utils.normalizeText(search))
    })
  }

  /** Copies the text to the clipboard; false when the browser did not allow it */
  public static async copyClipboard(text: string): Promise<boolean> {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      return false
    }
  }

  /** Message of a failed API call: the backend one when there is one */
  public static apiErrorMessage(error: any): string {
    return (error && error.response && error.response.data && error.response.data.message) || (error && error.message) || ''
  }

  /** Days from today to the date, negative when it has passed (the days left of a deadline) */
  public static daysFromToday(date: moment.MomentInput): number {
    return moment(date).diff(moment().startOf('day'), 'days')
  }

  /** Whole days from the date to today (0 for today or a future date) */
  public static daysSince(date: string): number {
    return Math.max(0, -Utils.daysFromToday(moment(date).startOf('day')))
  }

  /** Whether the account has the role in the CCP app; an inactive account has none */
  public static hasCcpRole(account: Account | undefined, role: string): boolean {
    return !!account && account.active !== false && (account.permissions || [])
      .some((permission: Permission) => permission.appId === APP_CCP && permission.role === role)
  }
}
